import { render, staticRenderFns } from "./ingredient-content.vue?vue&type=template&id=1c03d9ce&"
import script from "./ingredient-content.vue?vue&type=script&lang=js&"
export * from "./ingredient-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports